export default "__VITE_ASSET__Cqfm7gg$__"